import BaseReviewController from '../../components/base-review.controller';
import * as GiftValue from '../../constants/giftValue';

class GiftReviewController extends BaseReviewController {
    constructor(_, preFetchedData, componentRegistryService, componentDataService, disclosureService, loggerService, $state, constants, securityService, fileSaver, blobDownloadService) {
        super("giftReviewController",
            _,
            preFetchedData,
            componentRegistryService,
            componentDataService,
            disclosureService,
            loggerService,
            $state,
            constants,
            securityService,
            fileSaver,
            "/.coi.gift",
            constants.DisclosureType.Gift,
            blobDownloadService);
        this.lineManager = preFetchedData.lineManager;
        this.alternativeOfficer = preFetchedData.alternativeOfficer;
        this.executiveManagers = preFetchedData.alternativeOfficer ? [preFetchedData.alternativeOfficer] : [];

        this.giftApprovalOfficerType =  this._getGiftApprovalOfficerType(this.disclosureData.giftDetail.giftValue, this.disclosureData.giftDetail.totalValueOfGifts);
        this.reviewTitle = this.disclosureData.status === 'Draft' || this.disclosureData.status === 'Amending' || !this.disclosureData.displayId ? 'Disclose Gift' : `Gift ${this.disclosureData.displayId}`;
        
        this.strategyExists = this.disclosureData.managementStrategy !== null;
        this.managementStrategies = preFetchedData.managementStrategies;    
        this.acknowledgements = constants.GiftDetailsAcknowledgements;
        
    }

    _getGiftApprovalOfficerType(giftValue, totalValueOfGifts) {
        if (totalValueOfGifts) {
            return "executiveManager";
        }
        let value = this._.toInteger(giftValue);
        if (value > GiftValue.ExecutiveGiftValue) {
            return "executiveManager";
        }
        if (value > GiftValue.MinimumGiftValue ) {
            if (this.alternativeOfficer) {
                return "alternativeOfficer";
            }
            return "lineManager";
        }
        return "";
    }
}

GiftReviewController.$inject = ['_', 'preFetchedData', 'componentRegistryService', 'componentDataService', 'disclosureService', 'loggerService', '$state', 'constants', 'securityService', 'FileSaver', 'blobDownloadService'];

export default GiftReviewController;


// WEBPACK FOOTER //
// ./app/disclose/gift/gift.review.controller.js